import React from 'react';

function SettingsCard({ title, children }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: '24px 28px',
      marginBottom: 20,
      boxShadow: '0 2px 12px #0000000d',
    }}>
      <h3 style={{ margin: '0 0 14px 0', fontSize: 16, fontWeight: 700, color: '#1e1e2e' }}>
        {title}
      </h3>
      {children}
    </div>
  );
}

export default function Settings() {
  return (
    <div>
      <SettingsCard title="About HX">
        <p style={{ fontSize: 14, color: '#7f849c', lineHeight: 1.8, margin: 0 }}>
          by djambuken
        </p>
      </SettingsCard>
    </div>
  );
}
